import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '../auth'

const HomeView = () => import('../views/HomeView.vue')
const ParsingView = () => import('../views/ParsingView.vue')
const ReviewCenterView = () => import('../views/ReviewCenterView.vue')
const ReviewView = () => import('../views/ReviewView.vue')
const PricingView = () => import('../views/PricingView.vue')
const UserCenterView = () => import('../views/UserCenterView.vue')

const auth = useAuth()

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/review-center',
      name: 'review-center',
      component: ReviewCenterView,
      meta: { requiresAuth: true },
    },
    {
      path: '/review',
      name: 'review',
      component: ReviewView,
      meta: { requiresAuth: true },
    },
    {
      path: '/parsing',
      name: 'parsing',
      component: ParsingView,
      meta: { requiresAuth: true },
    },
    {
      path: '/auth',
      name: 'auth',
      redirect: (to) => {
        auth.openAuthDialog({
          redirect: String(to.query.redirect || '/'),
          initialTab: String(to.query.tab || 'login') === 'register' ? 'register' : 'login',
        })
        return { name: 'home' }
      },
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: PricingView,
    },
    {
      path: '/user-center',
      name: 'user-center',
      component: UserCenterView,
      meta: { requiresAuth: true },
    },
  ],
})

router.beforeEach(async (to) => {
  await auth.initAuth()

  if (to.meta.requiresAuth && !auth.currentUser.value) {
    return { name: 'home' }
  }

  return true
})

export default router